const ToolsPartsReturn = {
    "tools_parts_return": "Tools & Parts Return",
    "item": "Item",
    "remarks": "Remarks",
    "available_qty": "Available Qty",
    "return_qty": "Return Qty",
    "search": "Search",

    "list_title": "Tools & Parts Return To Store",
    "filter_title": "Tools & Parts Return Filter",
    "details_title": "Tools & Parts Return Details",

    "table_item": "Item",
    "table_type": "Type",
    "table_grn": "GRN No",
    "table_vendor": "Vendor",
    "table_return_qty": "Return Qty",
    "table_return_date": "Return Date",
    "table_remarks": "Remarks",
    "table_status": "Status",
}

export default ToolsPartsReturn;
